module.exports = __webpack_public_path__ + "static/media/Developmenticon02@2x.592ff0df.png";